import { Badge } from '@/components/ui/badge'
import type { ProjectStatus } from '@/types'
import { getStatusLabel } from '@/types'

const statusStyles: Record<ProjectStatus, string> = {
  New: 'bg-new text-new-foreground border-1 !border-new-foreground hover:bg-new',
  InProgress: 'bg-info text-info-foreground hover:bg-info',
  Done: 'bg-success text-success-foreground border-success-foreground hover:bg-success',
}

export function ProjectStatusBadge({ status }: { status: ProjectStatus }) {
  return (
    <Badge variant="secondary" data-testid={`project-status-${status}`} className={`${statusStyles[status] ?? ''}`}>
      {getStatusLabel(status)}
    </Badge>
  )
}
